import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { useObserveColumnsWidths } from './utils/useObserveColumnsWidths';
import { IOffersFeedProps } from '../../../types';
import { ScrollableWrapper } from '../../commonComponents';
import { HeaderRow } from '../HeaderRow';
import { WideOfferRow } from '../WideOfferRow';

type TWideOffersFeedProps = Omit<IOffersFeedProps, 'feedViewState'>;

export const WideOffersFeed: React.FC<TWideOffersFeedProps> = ({
  scrollable,
  selectable,
  data,
  showMoreBtn,
  activeOfferId,
  onOfferClick,
  viewedOffers,
  hideButton,
}) => {
  const { containerRef, rowRef, widths } = useObserveColumnsWidths();

  const content = (
    <>
      <div className={styles['grid']}>
        <HeaderRow columnsWidths={widths} />
      </div>
      <div ref={containerRef} className={cx(styles['grid'], styles['content'])}>
        {data.map((offer, i) => (
          <WideOfferRow
            key={offer.id}
            ref={i === 0 ? rowRef : undefined}
            data={offer}
            selectable={selectable}
            isActive={offer.id === activeOfferId}
            isViewed={viewedOffers.includes(offer.id)}
            onClick={() => onOfferClick(offer.id)}
            testId={`offers_history_listing_item_${offer.id}`}
            hideButton={hideButton}
          />
        ))}
        {showMoreBtn && <div className={styles['show-more']}>{showMoreBtn}</div>}
      </div>
    </>
  );

  if (scrollable) {
    return <ScrollableWrapper className={styles['scrollable']}>{content}</ScrollableWrapper>;
  }

  return content;
};
